// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2b27186c","453":"65e5b0d6","553":"d82e5a34"}[chunkId] + ".chunk.js";
};